import { combineReducers, createReducer, PayloadAction } from "@reduxjs/toolkit";

import { projectsSortColumnsSet, projectsSortSuccess } from "Store/Actions";

const projectIds = createReducer<string[]>([], {
  [projectsSortSuccess.type]: (_, { payload }: PayloadAction<string[]>) => payload
});

const columns = createReducer<[string, boolean][]>(
  [
    [`@modifiedOn`, true],
    [`@createdOn`, true]
  ],
  {
    [projectsSortColumnsSet.type]: (state, { payload }) => {
      if (payload == null) {
        return {};
      }

      return payload;
    }
  }
);

export const Sort = combineReducers({
  columns,
  projectIds
});
